import React from "react";
import { SVG, errorHandler, selectIcon } from "../selector";
import "./FormInput.scss";

import * as moment from "moment";
import TimePicker from "../TimePicker/TimePicker";
import { Calenders } from "./Calender";
import { CheckWidth, CheckValue } from "../../../services/CommonFunction";
import PropTypes from "prop-types";
import ToolTips, { InfoIcon } from "../../ReusableComponents/ToolTips/ToolTips";
import CustomSelect from "../CustomSelect/CustomSelect";
import { SetTimeUI } from "../../../containers/ActivityList/ClassForm/CommonClassFunc";
import { ToggleUI } from "../Toggle/Toggle";
import Images from "../Image/Image";
import { TagsInput } from "react-tag-input-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export const inputEvent = (e, status = "", value) => {
  if (e.which === 32 && !e.target.value.length) {
    e.preventDefault();
  } else if (status === "NumberTime") {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "NumberMinute") {
    if (value.length === 1) {
      // if(parseInt(value) > 5) {
      //     // e.preventDefault();
      // }
    } else if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "number") {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "price") {
    if (e.which < 48 || e.which > 57) {
      const value = Number(e.target.value);
      if (e.which === 46 && value === Math.floor(value)) {
      } else {
        e.preventDefault();
      }
    }
  } else if (status === "code") {
    if (e.which === 32) {
      e.preventDefault();
    }
  } else if (status === "string") {
    if (
      (e.which > 96 && e.which < 123) ||
      (e.which > 64 && e.which < 91) ||
      e.which === 32
    ) {
    } else {
      e.preventDefault();
    }
  } else if (status === "gymCode") {
    // if (!e.target.value.length) {
    //     if((e.which > 96 && e.which < 123) || (e.which > 64 && e.which < 91)) {
    //     } else {
    //         e.preventDefault();
    //     }
    // } else {
    // }
    if (
      e.which > 47 ||
      e.which < 58 ||
      (e.which > 96 && e.which < 123) ||
      (e.which > 64 && e.which < 91)
    ) {
    } else {
      e.preventDefault();
    }
  }
};

export const NumberTime = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  valid,
  validator,
  errors,
  ...props
}) => {
  const { value } = handler();
  const finalInvalid = CheckValue(meta.anotherControl)
    ? meta.anotherControl.invalid
    : invalid;
  return (
    <React.Fragment>
      <div style={{ position: "relative", height: "47px" }}>
        <input
          readOnly={meta.readOnly || false}
          className={`formInput${(touched || meta.valid) && finalInvalid ? " inputError" : ""
            }`}
          autoComplete="false"
          type="text"
          maxLength={meta.maxLength ? meta.maxLength : "2"}
          onKeyPress={(el) => inputEvent(el, meta.type || "NumberTime", value)}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
      </div>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "" : ""}
        </label>
      ) : null}
    </React.Fragment>
  );
};

export const NumberTime1 = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  valid,
  validator,
  errors,
  ...props
}) => {
  const { value, disabled, onBlur, onChange, onFocus } = handler();
  return (
    <React.Fragment>
      <div style={{ position: "relative", height: "47px" }}>
        <input
          onFocus={onFocus}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={(el) => {
            onChange(SetTimeUI(el.currentTarget.value));
            onBlur(el);
          }}
          readOnly={meta.readOnly || false}
          className={`formInput${(touched || meta.valid) && invalid ? " inputError" : ""
            }`}
          autoComplete="false"
          type="text"
          maxLength={meta.maxLength ? meta.maxLength : "2"}
          onKeyPress={(el) => inputEvent(el, meta.type || "NumberTime", value)}
          placeholder={`${meta.placeholder}`}
        />
      </div>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "" : ""}
        </label>
      ) : null}
    </React.Fragment>
  );
};

export const PasswordInputs = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
}) => (
  <div>
    {meta.label !== "" ? <label>{meta.label}</label> : null}
    <div style={{ position: "relative", height: "48px" }}>
      <input
        className="formInput"
        type={meta.type}
        rows="4"
        cols="50"
        maxLength={meta.maxLength ? meta.maxLength : ""}
        onKeyPress={(el) => inputEvent(el, "text")}
        placeholder={`${meta.placeholder}`}
        {...handler()}
      />
      {meta.valid && valid ? (
        <img className="tickIcon" src={selectIcon("verified")} alt="TICK" />
      ) : null}
    </div>
    <InputError1 meta={meta} hasError={hasError} display={touched && invalid} />
  </div>
);

export const TextInputs = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const type =
    meta.type &&
      meta.type !== "string" &&
      meta.type !== "gymCode" &&
      meta.type !== "number"
      ? meta.type
      : "text";
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
        </label>
      ) : null}
      <div className="input_outer">
        <input
          className={`formInput${touched && invalid ? " inputError" : ""}`}
          autoComplete="false"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
        <SVG
          style={{ display: meta.valid && valid ? "" : "none" }}
          className="tickIcon"
          src={selectIcon("verified")}
        />
      </div>
      {touched && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};
export const PasswordInput = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  let showPassword = false;
  const showPasswordKey = meta.showPasswordKey || "showPassword";
  if (CheckValue(meta.get(showPasswordKey))) {
    showPassword = meta.get(showPasswordKey).value;
  }
  const type = showPassword ? "text" : "password";
  const touch = (CheckValue(meta.touched) ? meta.touched : false) || touched;
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { value } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {CheckValue(errors) || CheckValue(validator) || meta.required
            ? "*"
            : ""}
          {tooltip}
        </label>
      ) : null}
      <div className="input_outer">
        <input
          readOnly={meta.readOnly || false}
          className={`formInput${touch && invalid ? " inputError" : ""}`}
          autoComplete="false"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
        {meta.controlInfo ? <span>{meta.controlInfo}</span> : null}
        {meta.valid && valid ? (
          <img className="tickIcon" src={selectIcon("verified")} alt="TICK" />
        ) : null}
        {!CheckValue(meta.show) || meta.show ? (
          <FontAwesomeIcon
            className={`showPassword${value.length ? "" : " disable"}`}
            icon={!showPassword ? faEyeSlash : faEye}
            onClick={() =>
              value.length ? meta.showPasswords(showPasswordKey) : null
            }
          />
        ) : null}
      </div>
      {touch && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};

export const TextInput = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const type =
    meta.type &&
      meta.type !== "string" &&
      meta.type !== "gymCode" &&
      meta.type !== "number"
      ? meta.type
      : "text";
  const touch = (CheckValue(meta.touched) ? meta.touched : false) || touched;
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { value } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {CheckValue(errors) || CheckValue(validator) || meta.required
            ? "*"
            : ""}
          {tooltip}
        </label>
      ) : null}
      <div className="input_outer">
        <input
          readOnly={meta.readOnly || false}
          className={`formInput${touch && invalid ? " inputError" : ""}`}
          autoComplete="false"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
        {meta.controlInfo ? <span>{meta.controlInfo}</span> : null}
        {meta.valid && valid ? (
          <img className="tickIcon" src={selectIcon("verified")} alt="TICK" />
        ) : null}
        {meta.maxLength && meta.showCount ? (
          <span className="showCount">
            {value.length}/{meta.maxLength}
          </span>
        ) : null}
      </div>
      {touch && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};
export const TextInputNew = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const type =
    meta.type &&
      meta.type !== "string" &&
      meta.type !== "gymCode" &&
      meta.type !== "price" &&
      meta.type !== "code" &&
      meta.type !== "number"
      ? meta.type
      : "text";
  const touch = (CheckValue(meta.touched) ? meta.touched : false) || touched;
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { value } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          <span className="label_text">
            {meta.label}
            {meta.label.trim() !== "" &&
              (CheckValue(errors) || CheckValue(validator) || meta.required)
              ? "*"
              : ""}
            {tooltip}
          </span>
        </label>
      ) : null}
      <div className="input_outer">
        <input
          readOnly={meta.readOnly || false}
          className={`formInput${touch && invalid ? " inputError" : ""}`}
          autoComplete="false"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
        {meta.onCrossClick ? (
          <SVG
            className="crossIcon"
            src={selectIcon("crossIcons")}
            onClick={meta.onCrossClick}
          />
        ) : null}
        {meta.controlInfo ? <span>{meta.controlInfo}</span> : null}
        {meta.maxLength && meta.showCount ? (
          <span className="showCount">
            {value.length}/{meta.maxLength}
          </span>
        ) : null}
      </div>
      {/* {touch && <InputError meta={meta} hasError={hasError} />} */}
    </React.Fragment>
  );
};

export const TextAreaNew = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  validator,
  errors,
  ...props
}) => (
  <React.Fragment>
    {meta.label !== "" ? (
      <label>
        {meta.label}
        {errors !== null || validator !== null ? "*" : ""}
        {meta.info ? <span className="info">{meta.info}</span> : null}
      </label>
    ) : null}
    <textarea
      className={`formInput${touched && invalid ? " inputError" : ""}`}
      onKeyPress={(el) => inputEvent(el)}
      maxLength={meta.maxLength ? meta.maxLength : "400"}
      placeholder={`${meta.placeholder}`}
      {...handler()}
    />
  </React.Fragment>
);

export const TextInput1 = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  validator,
  errors,
  ...props
}) => {
  const left = CheckWidth(props.value);
  const type = meta.type && meta.type !== "string" ? meta.type : "text";
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
        </label>
      ) : null}
      <div className="input_outer">
        {meta.valid && (hasError("pattern") || hasError("duplicate")) ? (
          <img className="errorIcon" src={selectIcon("notValid")} alt="TICK" />
        ) : null}
        {meta.valid && !props.active && hasError("pattern") ? (
          <span className="errorText" style={{ left: left + "px" }}>
            (Invalid Data)
          </span>
        ) : null}
        {meta.valid && !props.active && hasError("duplicate") ? (
          <span
            className="errorText"
            style={{ left: `${left + (hasError("pattern") ? 100 : 0)}px` }}
          >
            (Repeated Data)
          </span>
        ) : null}
        <input
          className="formInput"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          autoComplete="false"
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
      </div>
      {touched && meta.showError && (
        <InputError meta={meta} hasError={hasError} />
      )}
    </React.Fragment>
  );
};

export const ToogleInput = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  validator,
  errors,
  ...props
}) => {
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { onChange, value, disabled } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <div className="toogleInputDiv">
        <span className="text">{meta.text[0]}</span>
        <ToggleUI
          clas="noTextForm"
          changeView={(e) => onChange(!value)}
          value={value}
          disable={disabled}
          meta_id={"location"}
        />
        <span className="text">{meta.text[1]}</span>
      </div>
      {touched && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};
export const ToogleInputUI = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  validator,
  errors,
  ...props
}) => {
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { onChange, value, disabled } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <ToggleUI
        clas="yes_no"
        changeView={(e) => onChange(!value)}
        text={meta.text}
        value={value}
        disable={disabled}
        meta_id={"location"}
      />
      {touched && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};

export const TextArea = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  validator,
  errors,
  ...props
}) => (
  <React.Fragment>
    {meta.label !== "" ? (
      <label>
        {meta.label}
        {errors !== null || validator !== null ? "*" : ""}
      </label>
    ) : null}
    <textarea
      className={`formInput${touched && invalid ? " inputError" : ""}`}
      rows={meta.rows ? meta.rows : 4}
      cols={meta.cols ? meta.cols : 50}
      onKeyPress={(el) => inputEvent(el)}
      maxLength={meta.maxLength ? meta.maxLength : "400"}
      placeholder={`${meta.placeholder}`}
      {...handler()}
    />
    {touched && <InputError meta={meta} hasError={hasError} />}
    {meta.maxLength ? (
      <span className="char_limit">{meta.maxLength} character limit</span>
    ) : null}
  </React.Fragment>
);

export const CustomSelectBox = ({
  handler,
  hasError,
  meta,
  errors,
  validator,
  touched,
  invalid,
  ...props
}) => {
  const optionLists =
    meta.optionList instanceof Array ? meta.optionList : meta.optionList.value;
  const { onChange, value, disabled } = handler();
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {CheckValue(errors) || CheckValue(validator) ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <div style={{ flexGrow: "1" }}>
        <CustomSelect
          disabled={disabled}
          touch={touched}
          optionLists={optionLists}
          onClick={(el) => {
            onChange(el);
            // }} {...meta} hasError={hasError} invalid={invalid} formValue={[]} {...handler()} />
          }}
          {...meta}
          hasError={hasError}
          invalid={invalid}
          formValue={
            CheckValue(value) && value.length
              ? typeof value === "string"
                ? [{ value: value }]
                : [...value]
              : []
          }
          {...handler()}
        />
      </div>
    </React.Fragment>
  );
};
export const CustomSelectBoxNew = ({
  handler,
  hasError,
  meta,
  errors,
  validator,
  touched,
  invalid,
  ...props
}) => {
  const optionLists =
    meta.optionList instanceof Array ? meta.optionList : meta.optionList.value;
  const { onChange, value, disabled } = handler();
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {meta.label.trim() !== "" &&
            (CheckValue(errors) || CheckValue(validator))
            ? "*"
            : ""}
          {tooltip}
        </label>
      ) : null}
      <CustomSelect
        disabled={disabled}
        touch={touched}
        showError={false}
        optionLists={optionLists}
        onClick={(el) => {
          onChange(el);
          // }} {...meta} hasError={hasError} invalid={invalid} formValue={[]} {...handler()} />
        }}
        {...meta}
        hasError={hasError}
        invalid={invalid}
        formValue={
          CheckValue(value) && value.length
            ? typeof value === "string"
              ? [{ value: value }]
              : [...value]
            : []
        }
        {...handler()}
      />
    </React.Fragment>
  );
};
export const CustomTagBox = ({
  handler,
  hasError,
  meta,
  errors,
  validator,
  touched,
  invalid,
  ...props
}) => {
  const tooltip = meta.info ? (
    <ToolTips
      showTooltip={true}
      position="right"
      message={meta.info}
      className="infoIcon"
    >
      <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
    </ToolTips>
  ) : null;
  const { onChange, value } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <div className="tag_form">
        <TagsInput
          name="tag"
          {...handler()}
          onBlur={(e) => {
            if (e.target.value.length) {
              if (!value.includes(e.target.value)) {
                onChange([...value, e.target.value]);
              }
              e.target.value = "";
            }
          }}
        />
      </div>
    </React.Fragment>
  );
};

export const CustomRadio = (props) => (
  <div className="checkmarkContainer radio">
    {props.icon || null}
    {props.label ? <label>{props.label}</label> : null}
    <div className="checkmark_div">
      <input
        name={props.name}
        type="radio"
        value={props.value}
        onChange={() => props.change(props.value)}
        checked={
          CheckValue(props.radioValue) && props.radioValue === props.value
        }
      />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const CustomRadio1 = ({ label, name, value, checked, change }) => (
  <div className="checkmarkContainer">
    <label>{label}</label>
    <div className="checkmark_div">
      <input
        name={name}
        type="radio"
        value={value}
        onChange={() => change(value)}
        checked={checked}
      />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const RadioUI = ({
  label,
  value,
  handler = () => null,
  disabled,
  info,
}) => (
  <div className="checkmarkContainer">
    <label>
      {label}s
      {info ? (
        <ToolTips
          showTooltip={true}
          position="right"
          message={info}
          className="infoIcon"
        >
          <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
        </ToolTips>
      ) : null}
    </label>
    <div className="checkmark_div">
      <input type="radio" {...handler()} disable={disabled} />
      <span className={`checkmark radio`}></span>
    </div>
  </div>
);

export const FormRadioUI = ({
  label,
  defaultValue,
  handler = () => null,
  disabled,
  icon = null,
  info,
}) => {
  return (
    <div className="checkmarkContainer">
      {icon}
      <label>
        {label}
        {info ? (
          <ToolTips
            showTooltip={true}
            position="top"
            message={info}
            className="infoIcon"
          >
            {/* <FontAwesomeIcon className="info_icon" icon={faInfoCircle} /> */}
            <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
          </ToolTips>
        ) : null}
      </label>
      <div className="checkmark_div">
        <input {...handler("radio", defaultValue)} disable={disabled} />
        <span className={`checkmark radio`}></span>
      </div>
    </div>
  );
};
export const FormRadioUIBox = ({
  label,
  note,
  defaultValue,
  handler = () => null,
  disabled,
  icon = null,
  info,
}) => {
  return (
    <div className="checkmarkContainer radio_box">
      {icon}
      <label>
        {label}
        {note ? <span className="note">{note}</span> : null}
      </label>
      <input {...handler("radio", defaultValue)} readOnly={true} />
      <div className="checkmark_div">
        <span className={`checkmark radio`}></span>
      </div>
      {info ? (
        <ToolTips
          showTooltip={true}
          position="top"
          message={info}
          className="infoIcon radio_option"
        >
          {/* <FontAwesomeIcon className="info_icon" icon={faInfoCircle} /> */}
          <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
        </ToolTips>
      ) : null}
    </div>
  );
};

export const CheckboxUI = ({
  label,
  value,
  handler = () => null,
  disabled,
  info,
  clas,
}) => (
  <div className={`checkmarkContainer ${clas ? clas : ""}`}>
    <label>
      {label}
      {info ? <InfoIcon info={info} /> : null}
    </label>
    <div className="checkmark_div">
      <input
        type="checkbox"
        checked={value}
        {...handler()}
        disable={disabled}
      />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const CheckboxUIs = ({
  label,
  thumb = null,
  value,
  change,
  position = "right",
  disabled = false,
  info,
  containerClas,
  clas,
}) => (
  <div className={`checkmarkContainer ${containerClas || ""}`}>
    {CheckValue(thumb) ? (
      <div className="checkmarkContainer_image">
        <Images src={thumb} />
      </div>
    ) : null}
    {label ? (
      <label>
        {label}
        {info ? (
          <ToolTips
            showTooltip={true}
            position="right"
            message={info}
            className="infoIcon"
          >
            <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
          </ToolTips>
        ) : null}
      </label>
    ) : null}
    <div className="checkmark_div">
      <input
        type="checkbox"
        checked={value}
        onChange={change}
        disabled={disabled}
      />
      <span className={`checkmark ${clas || ""}`}></span>
    </div>
  </div>
);

export const CheckboxInput = ({ handler, meta }) => {
  const { value } = handler();
  return (
    <CheckboxUI
      clas={meta.clas}
      label={meta.label}
      value={value}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

export const CheckboxInput2 = ({ handler, meta }) => {
  const { value } = handler();
  return (
    <CheckboxUI
      clas={meta.clas}
      label={meta.label}
      value={meta.checked}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

export const RadioInput1 = ({ handler, meta }) => {
  return (
    <RadioUI
      label={meta.label}
      value={meta.value}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

export const RadioInput = ({ handler, meta }) => {
  const { value } = handler();
  return (
    <RadioUI
      label={meta.label}
      name={meta.name}
      value={value}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

// export const FormRadioInput = ({ handler, meta, errors, validator }) => {
//     return  <React.Fragment>
//         <label>
//             {meta.header}
//             {errors !== null || validator !== null ? '*' : ''}
//             {meta.info? <ToolTips showTooltip={true} position='right' message={meta.info}>
//                     <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
//                 </ToolTips>
//                 :
//             null}
//         </label>
//         <div className='radio_group'>
//             {meta.data.map((el,index) => <FormRadioUI icon={el.icon} key={index} label={el.label} defaultValue={el.value} handler={handler} disabled="false" info={el.info} />)}
//         </div>
//     </React.Fragment>
// }

export const FormRadioInput = ({ handler, meta, errors, validator }) => {
  return (
    <React.Fragment>
      <label>
        {meta.header}
        {errors !== null || validator !== null ? "*" : ""}
        {meta.info ? (
          <ToolTips
            showTooltip={true}
            position="top"
            message={meta.info}
            className="infoIcon"
          >
            <SVG className="infoIcon_svg" src={selectIcon("infoIcon")} />
          </ToolTips>
        ) : null}
      </label>
      <div className="radio_group">
        {meta.data.map((el, index) => (
          <FormRadioUI
            icon={el.icon}
            key={index}
            label={el.label}
            defaultValue={el.value}
            handler={handler}
            disabled="false"
            info={el.info}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export const CustomDate = (props) => {
  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <React.Fragment>
      <div
        className="customCalender"
        ref={ref}
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <p>{value !== null ? value : moment(new Date()).format("ll")}</p>
        <img className="calenderIcon" src={selectIcon("calender")} alt="icon" />
      </div>
    </React.Fragment>
  ));
  return (
    <React.Fragment>
      <label>{props.label}</label>
      <Calenders {...props} customInput={<ExampleCustomInput />} />
    </React.Fragment>
  );
};

export const CustomTime = ({
  handler,
  touched,
  meta,
  hasError,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const timerRef = React.createRef();
  const diff = 0;
  const { onChange, value } = handler();
  return (
    <React.Fragment>
      <label>
        {meta.label}
        {errors !== null || validator !== null ? "*" : ""}
      </label>
      <div className="customDatePicker">
        <TimePicker
          ref={timerRef}
          time={moment(value).format("HH:mm")}
          date={value}
          diff={diff}
          theme="Tribe"
          className={`timepicker${invalid ? " inputError" : ""}`}
          placeholder="Start Time"
          headerColor="#F22B5D"
          onSet={(val) => {
            let current = new Date(value).setHours(val.hours, val.minute, 0, 0);
            onChange(current);
          }}
        />
        <img
          className="calenderIcon"
          src={selectIcon("time")}
          alt="icon"
          style={{ cursor: "pointer" }}
          onClick={() => {
            timerRef.current.show(true);
          }}
        />
      </div>
      {<InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};

export const InputError = ({ hasError, meta }) => (
  <React.Fragment>
    {hasError("required") && (
      <span className={`error ${meta.errorClass || ""}`}>
        {meta.errorText ||
          `${meta.label.length ? meta.label + " is " : ""}required`}
      </span>
    )}
    {hasError("minLength") && (
      <span
        className={`error ${meta.errorClass || ""}`}
      >{`min length should be ${meta.minLength}`}</span>
    )}
    {hasError("maxLength") && (
      <span
        className={`error ${meta.errorClass || ""}`}
      >{`max length should be ${meta.maxLength}`}</span>
    )}
    {hasError("max") && (
      <span className="error">
        {meta.errorText || `max length should be ${meta.max}`}
      </span>
    )}
    {hasError("min") && (
      <span className="error">
        {meta.errorText || `max length should be ${meta.max}`}
      </span>
    )}
    {hasError("pattern") && (
      <span className="error">{`Invalid ${meta.label}`}</span>
    )}
    {hasError("invalidEmail") && (
      <span className="error">{`${errorHandler("invalidEmail")}`}</span>
    )}
    {hasError("maxDate") && (
      <span className="error">{`${errorHandler("maxDate")}`}</span>
    )}
    {hasError("invalid") && <span className="error">{`Invalid`}</span>}
    {hasError("wrongPassword") && (
      <span className="error">{`${errorHandler("wrongPassword")}`}</span>
    )}
    {hasError("wrongMemberShipcode") && (
      <span className="error">{`${errorHandler("wrongMemberShipcode")}`}</span>
    )}
    {hasError("alreadyMemberShipcode") && (
      <span className="error">{`${errorHandler(
        "alreadyMemberShipcode"
      )}`}</span>
    )}
    {hasError("alreadyEmail") && (
      <span className="error">{`${errorHandler("alreadyEmail")}`}</span>
    )}
    {hasError("timeError") && (
      <span className="error">{`${errorHandler(
        `timeError${meta.add ? "" : "Edit"}`
      )}`}</span>
    )}
    {hasError("passwordNotMatch") && (
      <span className="error">{`${errorHandler(`passwordNotMatch`)}`}</span>
    )}
  </React.Fragment>
);

export const InputError1 = ({ hasError, meta, display }) => (
  <span className="error" style={{ display: display ? "" : "none" }}>
    {hasError("required")
      ? `${meta.label.length ? meta.label + " is " : ""}required`
      : null}
    {hasError("minLength") ? `min length should be ${meta.minLength}` : null}
    {hasError("maxLength") ? `max length should be ${meta.maxLength}` : null}
    {hasError("pattern") ? `Invalid ${meta.label}` : null}
    {hasError("invalidEmail") ? `${errorHandler("invalidEmail")}` : null}
    {hasError("maxDate") ? `${errorHandler("maxDate")}` : null}
    {hasError("invalid") ? `Invalid` : null}
    {hasError("wrongPassword") ? `${errorHandler("wrongPassword")}` : null}
    {hasError("wrongMemberShipcode")
      ? `${errorHandler("wrongMemberShipcode")}`
      : null}
    {hasError("alreadyMemberShipcode")
      ? `${errorHandler("alreadyMemberShipcode")}`
      : null}
    {hasError("alreadyEmail") ? `${errorHandler("alreadyEmail")}` : null}
  </span>
);

InputError1.propTypes = {
  display: PropTypes.bool.isRequired,
};

InputError1.defaultProps = {
  display: true,
};
